import axiosInstance from "./AxiosInstance";
export function getboardinglist(param={}){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/employee/driver_boarding_list?${fparam}`)
}
export function searchshift(){
    return axiosInstance.get('api/transport/search_driver_shift')
}
export function employeein(data){
    return axiosInstance.post('api/employee/boarding_in',data)
}
 export function getDriverTravelHistory(driverId,param={}){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/transport/driver-riding-log/${driverId}?${fparam}`)
  }